import React from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

function dateTime(value, timezone) {
  if (!value) return "";
  return new Intl.DateTimeFormat("es-AR", {
    timeZone: timezone || undefined,
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}

export default function RestaurantTableOperationDialogs({
  reservation,
  customerReservation,
  onCloseReservation,
  onCloseCustomer,
}) {
  const mobile = useMediaQuery("(max-width:599.95px)", { noSsr: true });
  const customer = customerReservation?.customer;
  return (
    <>
      <Dialog open={Boolean(reservation)} onClose={onCloseReservation} fullWidth maxWidth="sm" fullScreen={mobile}>
        <DialogTitle sx={{ fontWeight: 950 }}>Reserva gastronómica</DialogTitle>
        <DialogContent dividers>
          {reservation ? (
            <Stack spacing={1.2}>
              <Typography sx={{ fontWeight: 950, fontSize: 20 }}>{reservation.customer?.fullName || "Cliente"}</Typography>
              <Typography variant="body2">{dateTime(reservation.startAt, reservation.timezone)} · {reservation.partySize} personas · {reservation.durationMinutes} min</Typography>
              <Chip size="small" label={reservation.status || "confirmada"} sx={{ alignSelf: "flex-start", fontWeight: 850 }} />
              {reservation.customer?.phone ? <Typography variant="body2">Teléfono: {reservation.customer.phone}</Typography> : null}
              {reservation.customer?.email ? <Typography variant="body2">Email: {reservation.customer.email}</Typography> : null}
              {reservation.notes ? <><Divider /><Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{reservation.notes}</Typography></> : null}
            </Stack>
          ) : null}
        </DialogContent>
        <DialogActions sx={{ p: 1.5 }}><Button onClick={onCloseReservation} sx={{ minHeight: 44, textTransform: "none", fontWeight: 900 }}>Cerrar</Button></DialogActions>
      </Dialog>

      <Dialog open={Boolean(customerReservation)} onClose={onCloseCustomer} fullWidth maxWidth="xs" fullScreen={mobile}>
        <DialogTitle sx={{ fontWeight: 950 }}>Cliente de la reserva</DialogTitle>
        <DialogContent dividers>
          {customer ? (
            <Stack spacing={1}>
              <Typography sx={{ fontWeight: 950, fontSize: 20 }}>{customer.fullName || "Cliente"}</Typography>
              <Typography variant="body2">{customer.phone || "Sin teléfono"}</Typography>
              <Typography variant="body2">{customer.email || "Sin email"}</Typography>
              {customerReservation?.customerId ? <Chip size="small" label="Vinculado al CRM" sx={{ alignSelf: "flex-start" }} /> : null}
            </Stack>
          ) : null}
        </DialogContent>
        <DialogActions sx={{ p: 1.5 }}><Button onClick={onCloseCustomer} sx={{ minHeight: 44, textTransform: "none", fontWeight: 900 }}>Cerrar</Button></DialogActions>
      </Dialog>
    </>
  );
}
